<template>
  <div class="modal-card" style="width: 400px">
    <header class="modal-card-head">
      <p class="modal-card-title" style="color: whitesmoke">{{ title }}</p>
    </header>
    <section class="modal-card-body">
      <template>
        <div id="SelectSendType" style="height: 250px">
          <div class="columnsis-vcentered">
            <!--受け渡し種別選択-->
            <div style="min-height: 250px; width: 100%">
              <th>受け渡し種別</th>
              <b-select
                v-model="sendType"
                name="sendType"
                data-vv-as="受け渡し種別"
                expanded
              >
                <option
                  v-for="sendTypeSelect in sendTypeSelectList"
                  :value="sendTypeSelect"
                  :key="sendTypeSelect.code"
                >
                  {{ sendTypeSelect.name }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </template>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="decide">決定</button>
      <button class="button" type="button" @click="$parent.close()">
        閉じる
      </button>
    </footer>
  </div>
</template>

<script>
const constInspection = require("../../utils/inspection");

export default {
  name: "SelectSendType",

  props: {
    title: { type: String },
    printType: { type: Number },
  },

  emits: ["selected"],

  components: {},

  data() {
    return {
      sendType: null,
    };
  },

  computed: {
    sentTypeNone: function () {
      return { code: 0, name: "" };
    },

    sendTypeSelectList: function () {
      let sendTypeSelectList = [this.sentTypeNone];

      switch (this.$props.printType) {
        case constInspection.PRINT_TYPE_MAP.patient.code:
          sendTypeSelectList = [
            ...sendTypeSelectList,
            ...constInspection.SEND_TYPES_PATIENT,
          ];
          break;
        case constInspection.PRINT_TYPE_MAP.hospital.code:
          sendTypeSelectList = [
            ...sendTypeSelectList,
            ...constInspection.SEND_TYPES_HOSPITAL,
          ];
          break;
      }

      return sendTypeSelectList;
    },
  },

  methods: {
    decide: async function () {
      // 入力チェック
      if (!this.sendType) {
        await this.showErrorMessage("受け渡し種別を選択してください。");
      }

      // イベント発火
      this.$emit("selected", this.sendType.code);

      // ダイアログクローズ
      this.$parent.close();

      return;
    },
  },

  created: function () {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/SelectSendType.vue